// extracted by mini-css-extract-plugin
module.exports = {"itemDetailFooter":"Cy-pX","itemDetailFooter-quantity":"EeVwh","itemDetailFooter-button":"_1Hsdo"};